/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Opportunitiesemptyareas2Inputs */

const en_opportunitiesemptyareas2 = /** @type {(inputs: Opportunitiesemptyareas2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No areas with demand in this window yet.`)
};

const de_opportunitiesemptyareas2 = /** @type {(inputs: Opportunitiesemptyareas2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Gebiete mit Nachfrage in diesem Zeitraum.`)
};

/**
* | output |
* | --- |
* | "No areas with demand in this window yet." |
*
* @param {Opportunitiesemptyareas2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const opportunitiesemptyareas2 = /** @type {((inputs?: Opportunitiesemptyareas2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Opportunitiesemptyareas2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_opportunitiesemptyareas2(inputs)
	return de_opportunitiesemptyareas2(inputs)
});
export { opportunitiesemptyareas2 as "opportunitiesEmptyAreas" }